import { render, staticRenderFns } from "./OfficialTag.vue?vue&type=template&id=22edd23f&scoped=true"
import script from "./OfficialTag.vue?vue&type=script&lang=js"
export * from "./OfficialTag.vue?vue&type=script&lang=js"
import style0 from "./OfficialTag.vue?vue&type=style&index=0&id=22edd23f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22edd23f",
  null
  
)

export default component.exports